import { render, staticRenderFns } from "./FaceRating.vue?vue&type=template&id=bc2ddd98&scoped=true"
import script from "./FaceRating.vue?vue&type=script&lang=ts"
export * from "./FaceRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2ddd98",
  null
  
)

export default component.exports